import MilitaryStatus from './MilitaryStatus';

export default MilitaryStatus;
